import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import Sentry from './lib/sentry'

// Force HTTPS in production
if (import.meta.env.PROD && window.location.protocol === 'http:') {
  window.location.href = window.location.href.replace('http:', 'https:')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="flex items-center justify-center h-screen"><div className="text-center"><h1 className="text-2xl font-bold text-red-600">حدث خطأ</h1><p className="text-gray-600 mt-2">نعتذر عن الإزعاج. يرجى تحديث الصفحة.</p></div></div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
